import { render } from "./ContentReport.vue?vue&type=template&id=20812f48&scoped=true"
import script from "./ContentReport.vue?vue&type=script&lang=js"
export * from "./ContentReport.vue?vue&type=script&lang=js"

import "./ContentReport.vue?vue&type=style&index=0&id=20812f48&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20812f48"]])

export default __exports__